module.exports = __webpack_public_path__ + "img/admin.9429b2a7.png";